import React, { ReactElement, ReactNode } from 'react'
import { Flex } from '../../styles/global_styles'
import { DivMain, TextBlock, Header, BottomHelpText, Icon, Asterisk, Title } from './styles'
import LiveTooltip from 'live/components/ui/tooltip'

export enum GeneralTextInputType {
    SIMPLE = 'simple',
    AREA = 'area'
}

interface GeneralInputTextProps {
    title?: string
    placeholder?: string
    bottomHelpText?: string
    tooltip?: string
    className?: string
    required?: boolean
    onChange?: (...args) => void
    value?: undefined | null | string
    children?: ReactNode
    variant: 'primary' | 'secondary'
    editMode: boolean
    error?: boolean
    border?: boolean
    inputType?: GeneralTextInputType
}

export const GeneralTextInput = ({
    title,
    placeholder,
    bottomHelpText,
    tooltip,
    className,
    required,
    onChange,
    value,
    children,
    variant,
    error = false,
    editMode,
    border,
    inputType = GeneralTextInputType.SIMPLE
}: GeneralInputTextProps): ReactElement => {
    return (
        <DivMain
            className={className}
            error={error}
            editMode={editMode}
            variant={variant}
            tabIndex={0}
            border={border}
            isArea={inputType === GeneralTextInputType.AREA}
        >
            <TextBlock className="textBlock">
                <Flex direction={'column'} justifyContent={'flex-start'} fillParent={true}>
                    <Header className="textBlockLabelHeader" variant={variant}>
                        {title && <Title>{title}</Title>}
                        {children && <> {children} </>}
                        {tooltip && (
                            <LiveTooltip className={className} content={tooltip as unknown as Node} position={'top'}>
                                <Icon className={'far fa-info-circle'} />
                            </LiveTooltip>
                        )}
                        {required && <Asterisk>*</Asterisk>}
                    </Header>
                    {inputType === GeneralTextInputType.SIMPLE ? (
                        <input
                            className={`${variant}_generalTextInput`}
                            placeholder={placeholder}
                            onChange={({ target }) => onChange(target.value)}
                            value={value}
                            disabled={!editMode}
                        />
                    ) : (
                        <textarea
                            className={`${variant}_generalTextInput`}
                            placeholder={placeholder}
                            onChange={({ target }) => onChange(target.value)}
                            value={value}
                            disabled={!editMode}
                        />
                    )}
                    {bottomHelpText && (
                        <BottomHelpText className="textBlockBottomHelpText">{bottomHelpText}</BottomHelpText>
                    )}
                </Flex>
            </TextBlock>
        </DivMain>
    )
}

export type { GeneralInputTextProps }
export default GeneralTextInput
